import { Theme } from '@mui/material/styles';
import { makeStyles } from 'tss-react/mui';
import { EndPageStyles } from '../interfaces/endPage';

export const EndStyles = makeStyles<EndPageStyles>()((theme: Theme, props) => ({
  marginText: {
    margin: props.basicFlow ? '0 0 1rem' : '3rem 0',
  },
  marginTop: {
    marginTop: '0',
  },
  linkGrid: {
    marginTop: '2rem',
    marginBottom: props.content || (props.label !== undefined && !props.label) ? 0 : '2rem', //reverse condition of task list
    display: 'flex',
    flexFlow: 'column wrap',
    wordBreak: 'break-word',
    '& .link': {
      marginBottom: '1.5rem',
    },
    [theme.breakpoints.between('sm', 'md')]: {
      flexFlow: 'row wrap',
      '& .link': {
        width: props.links && props.links.length >= 2 ? '48%' : '100%',
        marginBottom: '2rem',
      },
      '& .link:nth-of-type(2)': {
        marginLeft: '4%',
        marginBottom: '2rem',
      },
    },
    [theme.breakpoints.up('lg')]: {
      flexFlow: 'row nowrap',
      '& .link': {
        marginBottom: '1.25rem',
        justifyContent: 'space-around',
        width: props.links && props.links.length >= 3 ? (props.links.length >= 2 ? '32%' : '48%') : '100%',
      },
      '& .link:nth-of-type(2)': {
        marginLeft: '2%',
        marginRight: '2%',
      },
    },
  },
  taskListLabelContainer: {
    overflow: 'hidden',
  },
  taskListLabel: {
    '@supports not (-ms-high-contrast: none)': {
      display: 'flex',
      color: props.nextStepLabelColor,
      marginTop: '2rem',
      '&::after': {
        content: '""',
        flex: '1 1',
        borderColor: props.nextStepLabelColor,
        borderBottom: '2px solid',
        margin: 'auto',
        marginLeft: '1rem',
      },
      [theme.breakpoints.up('sm')]: {
        marginTop: props.content || props.candidateFeedbackEnabled ? '2.5rem' : 0,
      },
      [theme.breakpoints.up('lg')]: {
        marginTop: props.content || props.candidateFeedbackEnabled ? '3rem' : 0,
      },
    },
    '@media screen and (-ms-high-contrast: none)': {
      position: 'relative',
      color: props.nextStepLabelColor,
      '&::after': {
        content: '""',
        position: 'absolute',
        top: '50%',
        height: '1px',
        borderBottom: '2px solid',
        width: '100%',
        marginLeft: '1rem',
      },
      [theme.breakpoints.up('sm')]: {
        marginTop: props.content ? '2.5rem' : 0,
      },
      [theme.breakpoints.up('lg')]: {
        marginTop: props.content ? '3rem' : 0,
      },
    },
  },
  basicDivider: {
    display: 'flex',
    color: props.nextStepLabelColor,
    marginTop: '1.25rem',
    marginBottom: '2rem',
    '&::after': {
      content: '""',
      height: '1px',
      borderBottom: '2px solid',
      width: '80%',
      margin: 'auto',
    },
  },
}));
